import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CustomSVG } from 'components';
import { useContent, useCurrentUser } from 'hooks';
import { isAdminUser, isGroupModeratorOfContent } from 'helpers';

const useStyles = makeStyles(theme => ({
  grid: {
    padding: `${theme.spacing(0)}px ${theme.spacing(2)}px`,
    cursor: 'pointer',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

const Reposts: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const content = useContent();

  const { slack_channels, ms_teams_channels } = content;

  if (!isAdminUser(currentUser) && !isGroupModeratorOfContent(content, currentUser)) {
    return null;
  }

  return (
    <Fragment>
      {slack_channels?.length > 0 && (
        <Fragment>
          <Grid container alignItems="center" className={classes.grid}>
            <CustomSVG name={'slack'} className={classes.icon} />
            <Typography>
              <p>{t('content:shared_to_slack')} </p>
            </Typography>
          </Grid>
        </Fragment>
      )}
      {ms_teams_channels?.length > 0 && (
        <Fragment>
          <Grid container alignItems="center" className={classes.grid}>
            <CustomSVG name={'msteams'} className={classes.icon} />
            <Typography>
              <p>{t('content:shared_to_msteams')}</p>
            </Typography>
          </Grid>
        </Fragment>
      )}
      <Divider />
    </Fragment>
  );
};

export default Reposts;
